var getters = {
  // user
  token: function token(state) {
    return state.user.token;
  },
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  loginStatus: function loginStatus(state) {
    return state.user.loginStatus;
  },
  getWechatSignUrl: function getWechatSignUrl(state) {
    return state.app.wechatSignUrl;
  }
};
export default getters;